<template>
    <a-select :allowClear="true" style="width:100%" show-search :mode="mode" :value="valueSelf"
        :label-in-value="labelInValue" placeholder="输入搜索" :default-active-first-option="false" :show-arrow="true"
        :not-found-content="fetching ? undefined : '暂无数据'" option-label-prop="label"
        :filter-option="searchSource ? false : filterOption" :maxTagCount="3" @search="handleSearch" @change="handleChange"
        @focus="focusFun" @blur="blurFun">
        <div slot="dropdownRender" slot-scope="menu">
            <div v-if="!normal" class="spaceBetween"
                style="border-bottom:1px solid #eee;padding:10px 10px;color:#999;font-size:12px;">
                <div>{{ headNameFirst }}</div>
                <div>{{ headNameSecond }}</div>
            </div>
            <v-nodes :vnodes="menu" />
        </div>
        <a-spin v-if="fetching" slot="notFoundContent" size="small" />
        <a-select-option v-for="d in dataList" :key="d[valuePorpReal || valuePorp]" :value="d[valuePorpReal || valuePorp]"
            :label="d[labelPorp]" :title="d[labelPorp]" :disabled="other == true ? d.cstNm == userObj.cstNm : false">
            <div class="spaceBetween" style="font-size:12px; flex-wrap:nowrap">
                <div>{{ d[labelPorp] }}</div>
                <div v-if="!normal">{{ d[valuePorp] }}</div>
            </div>
        </a-select-option>
    </a-select>
</template>

<script>
import { mapGetters } from "vuex";
import debounce from 'lodash/debounce';
export default {
    props: {
        // 选项数组
        dataSource: {
            type: Array,
            required: false,
            default: function () {
                return [];
            }
        },
        // 选项第一列名称
        headNameFirst: {
            type: String,
            required: false,
            default: function () {
                return "";
            }
        },
        // 选项第二列名称
        headNameSecond: {
            type: String,
            required: false,
            default: function () {
                return "";
            }
        },
        // value绑定的属性名(用于绑定选项的value、key、第二例展示的数据)：如果选项数据不是{value：xxx,name:xxx}的形式时使用
        valuePorp: {
            type: String,
            required: false,
            default: function () {
                return "name";
            }
        },
        // value绑定的属性名，用于绑定选项的value、key：优先级 > valuePorp
        valuePorpReal: {
            type: String,
            required: false,
            default: function () {
                return "";
            }
        },
        // label绑定的属性名，如果选项数据不是{value：xxx,name:xxx}的形式时使用
        labelPorp: {
            type: String,
            required: false,
            default: function () {
                return "value";
            }
        },
        // 选项展示模式：单选、多选
        mode: {
            type: String,
            required: false,
            default: function () {
                return 'default';
            }
        },
        // 是否启用远程搜索，true：启用，远程搜索方法为handleSearch绑定的方法   false：启用本地搜索（本地搜索组件自带无需定义搜索方法）
        searchSource: {
            type: Boolean,
            required: false,
            default: function () {
                return false;
            }
        },
        // 为v-model绑定的值
        value: {
            type: [String, Number, Object, Array],
            required: false,
            default: function () {
                return null;
            }
        },
        // 是否为普通模式，即不是两列选项模式
        normal: {
            type: Boolean,
            required: false,
            default: function () {
                return false;
            }
        },
        // v-model绑定的值是否为对象模式
        labelInValue: {
            type: Boolean,
            required: false,
            default: function () {
                return true;
            }
        },
        other: {
            type: Boolean,
            default: function () {
                return false;
            }
        }
    },
    model: {
        prop: "value",
        event: "changeVal"
    },
    name: "select-search",
    data() {
        this.handleSearch = debounce(this.handleSearch, 500);
        return {
            dataList: this.utils.deepClone(this.dataSource),
            valueSelf: this.mode == 'multiple' ? [] : this.value,
            fetching: false
        };
    },
    mounted() {
        console.log(this.value)
    },
    computed: {
        ...mapGetters({
            userObj: "home/getUserObj"
        }),
    },
    components: {
        VNodes: {
            functional: true,
            render: (h, ctx) => ctx.props.vnodes,
        }
    },
    methods: {
        handleSearch(value) {
            this.fetching = true;
            this.$emit("handleSearch", value);
        },
        focusFun() {
            this.fetching = true;
            this.$emit("handleSearch", "");
        },
        blurFun() {
            this.dataList = [];
        },
        handleChange(obj) {
            let item = this.dataList.find(i => i[this.valuePorp] == obj.key);
            this.valueSelf = obj;
            this.$emit("changeVal", this.valueSelf || {}, item);
            this.$emit("handleChange", this.valueSelf || {}, item);
        },
        filterOption(input, option) {
            if (this.searchSource) return;
            const value = String(option.componentOptions.propsData.value);
            const label = option.componentOptions.propsData.label;
            return (value.indexOf(input) >= 0 || label.indexOf(input) >= 0);
        }
    },
    watch: {
        dataSource: {
            handler(newVal, oldVal) {
                this.dataList = this.utils.deepClone(newVal);
                if (this.fetching) this.fetching = false;
            },
            deep: true
        },
        value(newValue) {
            this.valueSelf = newValue;
        }
    }
};
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/components/ui/select-search/select-search.vue